<span [class]="className" [tooltip]="tooltip">{{value | format:valueType}}</span>
